if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"fe-sim-onboarding","remotes":[{"alias":"fe_common","name":"fe_common","entry":"https://local.giffgaff.com:3000/fe-common/static/mf-manifest.json","shareScope":"default","externalType":"script"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(32|686|789)$/.test(chunkId)},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {"fe_common":[{"alias":"fe_common","name":"fe_common","entry":"https://local.giffgaff.com:3000/fe-common/static/mf-manifest.json","shareScope":"default","externalType":"script"}]}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}